// extracted by mini-css-extract-plugin
module.exports = {"item":"PlanItem_style_item__1Zf-8","plantext":"PlanItem_style_plantext__h6IUm","planEmpty":"PlanItem_style_planEmpty__2zDaT"};